//
//
//
//

export default {
    name: "ContactDetail"
}
